export default "__VITE_ASSET__Cwe0YeK0__"